import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import type { AnalyticEventData } from '@gonfalon/analytics/types';

const trackObservabilityEvent = createTrackerForCategory('Observability');

// Event name matches the one Vega already emits, so existing dashboards keep working. `component`
// tells the surfaces apart now that every connect affordance is instrumented, not just Vega's two.
export const trackGitHubConnectClicked = (properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI GitHub Connect Clicked', properties);
